import React from "react";
import TopNav from "./TopNav";
import BottomBar from "./BottomBar";
import { useTheme } from "../contexts/ThemeContext";
import { useVoice } from "../voice/VoiceProvider";

export default function AppShell({ children }) {
  const { mobile } = useTheme();
  const { hideBottomBar } = useVoice() || {};
  const inner = (
    <div style={{ minHeight: "100vh", paddingTop: 56, paddingBottom: hideBottomBar ? 0 : 96, background: "var(--dnya-bg)", color: "var(--dnya-text)" }}>
      <TopNav />
      <main
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          // Responsive padding per Section 5c
          padding: "20px clamp(16px, 4vw, 32px) 32px",
        }}
      >
        {children}
      </main>
      {!hideBottomBar && <BottomBar />}
    </div>
  );
  if (mobile) {
    return (
      <div style={{ minHeight: "100vh", background: "var(--dnya-bg-2)", padding: "20px 0" }}>
        <div className="mobile-frame" style={{ background: "var(--dnya-bg)" }}>{inner}</div>
      </div>
    );
  }
  return inner;
}
